<template>
  <el-container class="body_container">
    <!--<el-row class="head_line">直播</el-row>-->
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex">
        <el-col class="body_title">协会</el-col>
        <el-col style="text-align: right;">
          <el-form :model="searchVo" ref="search" :inline="true" size="small">
            <el-form-item style="margin-right: 10px">
              <el-button @click="add('addLive')" type="primary">添加</el-button>
              <!--添加律协弹窗组件 -->
              <add-association ref="addBranch" v-if="addAssociationVisible" :visible.sync="addAssociationVisible"
                               :assId="assId" :pid="pid" :status="status" :assName="assName" :level="MAX_LEVEL" @callFather="reload"></add-association>
            </el-form-item>
            <el-form-item style="margin: 0px">
              <el-input v-model="searchVo.title" placeholder="查询" style="width: 200px">
                <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-table
        :data="tableData"
        style="width: 100%;"
        row-key="id"
        highlight-current-row
        border
        @current-change="handleCurrentChange"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column
          prop="name"
          label="协会名称"
          min-width="200px">
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="code"-->
          <!--label="代码"-->
          <!--min-width="160px">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="pid"-->
          <!--label="上级"-->
          <!--min-width="200px">-->
        <!--</el-table-column>-->
          <el-table-column
            prop="address"
            label="地址"
            min-width="220px">
          </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          min-width="120px">
        </el-table-column>
        <el-table-column prop="id" label="操作" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.pid!==0">
              <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <i class="el-icon-edit" @click="checkAssociation(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i class="el-icon-delete" @click="delAssociation(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              <!--</el-button>-->
            </span>
            <span v-else>
              <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <i class="el-icon-edit" @click="checkAssociation(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <!--&nbsp;-->
            <!--<i class="el-icon-delete" @click="delAssociation(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>-->
              <!--</el-button>-->
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>



<script>
import Association from './association/Ass.vue'
import association from '@/api/association'
export default{
  name: 'Association',
  data() {
    return {
      status: '',
      assId: null,
      pid: null,
      assName: '',
      isLoading: false,// 是否加载
      // tree数据
      tableData: [],
      addAssociationVisible: false,
      association: {
        id: 0,
        name: '',
        code: '',
        address: '',
        phone: '',
        pid: null
      },
      lawyers: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        title: ''
      },
      MAX_LEVEL: null
    }
  },
  methods: {
    reload () {
      // 树形数据
      association.find({name: this.searchVo.title }).then(res => {
        let list = res.data.data[0]
        this.tableData = []
        this.tableData.push(list)
        console.log(this.tableData)
      })
    },
    checkAssociation (row) {
      this.status = ''
      this.assId = row.id
      this.pid = row.pid
      this.addAssociationVisible = true
    },
    delAssociation (row) {
      this.$confirm('删除前请确认该协会无下级单位', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        association.del({id: row.id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code===0){
            this.reload()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 保存
    save () {
      association.save(this.association).then(res => {
        this.$message.info(res.data.message)
        if (res.data.code===0){
          this.reload()
        }
      })
    },
    search() {
      this.reload()
    },
    add (refForm) {
      if (this.assId == null){
        this.$message.warning("请选择一个协会！")
        return
      }
      if (this.MAX_LEVEL === 3){
        this.$message.warning("当前单位无法新增下级单位！")
        return false;
      }
      this.status = 'add'
      if (this.$refs[refForm]) {
        this.$refs[refForm].initForm()
      }
      this.addAssociationVisible = true
    },
    handleCurrentChange(val) {
      console.log(val)
      this.assId = val.id
      this.assName = val.name
      this.MAX_LEVEL = val.grade
    }
  },
  components: {
    'add-association': Association
  },
  created () {
    this.reload()
  }
}
</script>
<style>
  .readonly input{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/lawyer/Association1.vue